import React from 'react';
import { PopUp } from '../PopUp';
import { Guess } from '../../Guess/Guess';
import { Score } from '../../Score/Score';

interface HowToPlayProps{
  closeCallback: () => void;
}

export class HowToPlay extends React.Component<HowToPlayProps> {
  render(): React.ReactNode {
    return (
      <PopUp closeCallback={() => this.props.closeCallback()}>
        <h2 className='w-4/5 text-2xl font-bold text-center border-b-2 md:text-3xl'> How to Play </h2>
        <h3 className='w-[70%] text-xl font-bold text-center md:text-2xl border-b-[1px]'> Game Rules </h3>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> You have 8 guesses to figure out the secret 4 color sequence. </p>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> The secret code is made up of four unique colors </p>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> Your guess must also be made up of four unique colors </p>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> After each submitted code you will recieve a score for that code </p>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> The score consists of a certain number of hits and blows, the order of these is unrelated to the order of your guess. </p>

        <p className='w-[70%] text-xl font-bold text-center md:text-2xl border-b-[1px]'> By Example </p>
        <p className='w-4/5 text-[10px] text-center md:text-sm font-semibold mb-2'> Imagine the final code is </p>
        <Guess guess={['Red', 'Blue', 'Yellow', 'Black']} score={[]}/>
        <p className='w-4/5 text-[10px] text-center md:text-sm font-semibold mt-2 mb-2'> and this is the result of your guess </p>
        <Guess guess={['White', 'Yellow', 'Green', 'Black']} score={['Green', 'Yellow', 'Red', 'Red']}/>

        <h3 className='w-[70%] text-xl font-bold text-center md:text-2xl border-b-[1px]'> Heres why </h3>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> You placed the color black correctly, which appears in the score as a green square.  </p>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> You guessed the color yellow, but not in the right place, which appears in the score as a yellow square. </p>
        <p className='w-2/3 text-[10px] text-left md:text-sm my-1'> Your other two guesses, green and white, are completely wrong, and appears in the score as a blank square.  </p>
      </PopUp>
    );
  }
}
